import React from 'react'
import { withRouter } from 'react-router-dom'
import { AuthContext } from '../../../main/authProvider'
import { ColumnGroup } from 'primereact/columngroup'
import { Row } from 'primereact/row'
import HandleErrorService from '../../../app/service/handleErrorService'
import GeneralServices from '../../../app/service/generalServices'
import ConstantsUtil from '../../../context/constantsUtil'
import DateIntervalCalendar from '../../../components/calendar/dateIntervalCalendar'
import Card from '../../../components/card'
import { Button } from 'primereact/button'
import { InputSwitch } from 'primereact/inputswitch'
import EmpresasMultiSelect from '../../../components/empresas/empresasMultiSelect'
import FormGroup from '../../../components/form-group'
import CentralService from '../../../app/service/central/centralService'
import TransactionService from '../../../app/service/estoque/transactionService'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import TableFilters from '../../../components/tableFilters'
import DetalhamentoMovimentacaoProductDialog from '../../../components/product/detalhamentoMovimentacaoProductDialog'
import { classNames } from 'primereact/utils'
import AuthService from '../../../app/service/authService'


class InflacaoProdutosCompra extends React.Component {

    constructor(){
        super()
        this.centralService = new CentralService();
        this.transactionService = new TransactionService()
        this.tableFilters = new TableFilters()
        this.generalServices = new GeneralServices()
        this.dt = React.createRef()
    }

    state = {

        loading: false,

        selectedDateFilterType: '',
        missingFilterType: false,
        missingAnyDate: false,
        initialDate: '',
        initialDateView: '',
        finalDate: '',
        finalDateView: '',

        unificarEmpresas: '',
        selectedEmpresas: [],
        inputEmpresasErrorClass: '',
        errorEmpresasErrorMessage: '',

        habilitaBusca: true,

        relatorioInflacao: {},
        frontendList: [],

        selectedEmpresaList: [],
        selectedProdutoList: [],
        selectedFornecedorList: [],
        selectedInflacaoTotalList: [],

        displayDetalhamentoDialog: false,
        productDetalhamento: null,

    }

    handleDateFilterChange = (selectedDateFilterType) => {
        this.setState({selectedDateFilterType})
    }

    handleDateChange = async (initialDate, finalDate) => {
        await this.handleInitialMonthDateChange(initialDate)
        await this.handleFinalMonthDateChange(finalDate)
    }

    handleInitialMonthDateChange = async (initialDate) => {
        await this.setState({initialDate})
        await this.setState({initialDateView: GeneralServices.convertBrStringToJsDate(initialDate)})
    }

    handleFinalMonthDateChange = async (finalDate) => {
        await this.setState({finalDate})
        await this.setState({finalDateView: GeneralServices.convertBrStringToJsDate(finalDate)})
    }    

    handleUnificarChange = (e) => {
        this.setState({unificarEmpresas: e.value})
        if(!e.value){
            this.setState({selectedEmpresas: []})
        }
    }

    toggleButton = async () => {
        if(!this.state.habilitaBusca){
            //Clicou em "Voltar"
            // await this.setState({DREConsolidado: ''})
        }
        await this.setState({habilitaBusca: !this.state.habilitaBusca})
    }

    resetView = () => {
        this.setState({inputContaContabilErrorClass: ''})

        this.setState({missingFilterType: false})
        this.setState({missingAnyDate: false})

        this.setState({inputEmpresasErrorClass: ''})
        this.setState({errorEmpresasErrorMessage: ''})

        this.setState({
            selectedInflacaoTotalList: [],
            selectedFornecedorList: [],
            selectedProdutoList: [],
            selectedEmpresaList: [],
        })

    }

    checkData = () => {

        var check = true

        if(!this.state.selectedDateFilterType){
            this.setState({missingFilterType: true})
            check=false
        }
        
        if(!this.state.initialDate || !this.state.finalDate){
            this.setState({missingAnyDate: true})
            check=false
        }

        if(this.state.unificarEmpresas){
            if(!this.state.selectedEmpresas || this.state.selectedEmpresas.length === 0){
                this.setState({inputEmpresasErrorClass: ConstantsUtil.primereactInputErrorClass})
                this.setState({errorEmpresasErrorMessage: ConstantsUtil.errorSelecioneEmpresasMessage})
                check = false
            }
        }        

        return check
    }

    callSearch = () => {

        this.resetView()

        if(this.checkData()){
            // this.setState({qtdMeses:  GeneralServices.calcularMeses(this.state.initialDate, this.state.finalDate)})
            this.search()
        }
    }

    search = () => {
        this.setState({loading: true})
        this.toggleButton()

        this.getRelatorioInflacao()
        .then(async response => {
            // console.log("response: ", response.data)
            // await this.trataResponse(response.data)
            await this.setState({relatorioInflacao: response.data})
            this.trataLista(response.data.itemList)
            await this.setState({frontendList: JSON.parse(JSON.stringify(response.data.itemList))})
        })
        .catch(error => {
            // console.log("error: ", error)
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            this.setState({loading: false})
        })
    }

    trataItem = (item) => {
        item.nomeEmpresa = item.empresa ? item.empresa.nome : ''
        item.nomeProduto = item.buyProduct.descricao
        item.nomeFornecedorConcatenado = item.buyProduct.nomeFornecedor ? `${item.buyProduct.nomeFornecedor} (${item.buyProduct.cnpjFornecedor})` : ''
        item.inflacaoTotalPeriodo = item.inflacaoTotalPeriodo ? item.inflacaoTotalPeriodo : ''
        
        let inflacaoTotalPeriodoFormatadaString = item.inflacaoTotalPeriodo
        if(inflacaoTotalPeriodoFormatadaString){
            inflacaoTotalPeriodoFormatadaString*=100
            inflacaoTotalPeriodoFormatadaString = GeneralServices.showFormattedIfNotNull(inflacaoTotalPeriodoFormatadaString, true)
            inflacaoTotalPeriodoFormatadaString = `${inflacaoTotalPeriodoFormatadaString}%`
        }
        item.inflacaoTotalPeriodoFormatadaString = inflacaoTotalPeriodoFormatadaString
    }

    trataLista = itemList => {
        itemList.forEach(item => {this.trataItem(item)})
    }

    getRelatorioInflacao = () => {
        if(this.state.unificarEmpresas){
            return this.centralService.getRelatorioInflacaoUnificado(this.state.initialDate, this.state.finalDate, this.state.selectedEmpresas)
        }
        else{
            return this.transactionService.getRelatorioInflacao(this.state.initialDate, this.state.finalDate)
        }
    }

    checkListaMesesPreenchida = () => {
        return (this.state.relatorioInflacao && this.state.relatorioInflacao.descricaoMesesList && this.state.relatorioInflacao.descricaoMesesList.length !== 0)
    }

    onFilter = async (filterEvent) => {

        await this.generalServices.sleep(100)

        // console.log("onFilter: ", this.state)

        let createFilterObj = (label, value) => {
            let obj = {label, value}
            return obj
        }

        let filters = []
        if(this.state.selectedEmpresaList.length > 0){
            filters.push(createFilterObj('nomeEmpresa', this.state.selectedEmpresaList))
        }
        if(this.state.selectedProdutoList.length > 0){
            filters.push(createFilterObj('nomeProduto', this.state.selectedProdutoList))
        }
        if(this.state.selectedFornecedorList.length > 0){
            filters.push(createFilterObj('nomeFornecedorConcatenado', this.state.selectedFornecedorList))
        }
        if(this.state.selectedInflacaoTotalList.length > 0){
            filters.push(createFilterObj('inflacaoTotalPeriodoFormatadaString', this.state.selectedInflacaoTotalList))
        }

        let frontendList = JSON.parse(JSON.stringify(this.state.relatorioInflacao.itemList))

        if(filters.length > 0){
            // console.log("filters: ", filters)
            filters.forEach(filter => {
                frontendList = frontendList.filter(item => filter.value.includes(item[filter.label]))
            })

            this.adicionaLinhaMedia(frontendList)
        }

        this.setState({frontendList})

    }

    adicionaLinhaMedia = (frontendList) => {
        
        let mesesSizeList = this.state.relatorioInflacao.descricaoMesesList.length

        let totaisRelatorioMesList = []
        for(let i = 0; i < mesesSizeList; i++){
            totaisRelatorioMesList.push({
                descricaoMes: this.state.relatorioInflacao.descricaoMesesList[i],
                valorCusto: 0.0,
            })
        }

        // console.log("totaisRelatorioMesList: ", totaisRelatorioMesList)

        for(let i = 0; i < mesesSizeList; i++){

            let quantidadeItemsComValorCustoNoMes = 0
            frontendList.forEach(item => {
                let relatorioMesList = item.relatorioMesList
                if(relatorioMesList.length > i){
                    let relatorioMes = relatorioMesList[i]
                    let totaisRelatorioMes = totaisRelatorioMesList[i]
                    totaisRelatorioMes.valorCusto += relatorioMes.valorCusto
                    if(relatorioMes.valorCusto){
                        quantidadeItemsComValorCustoNoMes++
                    }
                }
            })
            
            let quocienteMedia = Math.min(quantidadeItemsComValorCustoNoMes, frontendList.length)
            totaisRelatorioMesList[i].valorCusto = totaisRelatorioMesList[i].valorCusto/quocienteMedia

        }

        let calculaInflacao = (valorMesAtual, valorMesReferencia) => {
            if(!valorMesReferencia){
                return 0.0
            }
            return (valorMesAtual - valorMesReferencia)/valorMesReferencia
        }

        for(let i = 1; i < mesesSizeList; i++){
            // let valorCusteMesInicial = totaisRelatorioMesList[0].valorCusto
            let valorCusteMesInicial = this.buscaValorCustoMesInicial(totaisRelatorioMesList)
            let valorCustoMesAnterior = totaisRelatorioMesList[i-1].valorCusto
            let totaisRelatorioMes = totaisRelatorioMesList[i]
            let valorCustoMesAtual = totaisRelatorioMes.valorCusto
            
            if(valorCustoMesAtual){
                // console.log("ue: ", valorCustoMesAtual, valorCustoMesAnterior, valorCusteMesInicial)
                totaisRelatorioMes.inflacaoMensalPocentagem = calculaInflacao(valorCustoMesAtual, valorCustoMesAnterior)
                totaisRelatorioMes.inflacaoAcumuladaPocentagem = calculaInflacao(valorCustoMesAtual, valorCusteMesInicial)
            }
        }

        let inflacaoTotalPeriodo = 0.0
        for(let i = (mesesSizeList - 1); i >= 0 ; i--){
            let ultimaInflacaoAcumulada = totaisRelatorioMesList[i].inflacaoAcumuladaPocentagem
            if(ultimaInflacaoAcumulada){
                inflacaoTotalPeriodo = ultimaInflacaoAcumulada
                break
            }
        }

        // let totaisItem = JSON.parse(JSON.stringify(frontendList[0]))
        let totaisItem = {
            buyProduct: {
                descricao: ConstantsUtil.mediaTableUpperCaseLabel,
            },
            nomeProduto: ConstantsUtil.mediaTableUpperCaseLabel,
            relatorioMesList: totaisRelatorioMesList,
            inflacaoTotalPeriodo
        }

        this.trataItem(totaisItem)

        // console.log("frontendList antes do push: ", frontendList)
        frontendList.push(totaisItem)
    }

    buscaValorCustoMesInicial = relatorioMesList => {
        for(const item of relatorioMesList){
            let valorCusto = item.valorCusto
            if(valorCusto){
                return valorCusto
            }
        }
    }

    rowClass(rowData) {
        return {
            [ConstantsUtil.totaisTableLabel]: rowData.buyProduct.descricao === ConstantsUtil.mediaTableUpperCaseLabel
        }
    }

    viewDetalhamentoQuantidade = async (rowData, descricaoMes) => {
        // console.log("viewDetalhamentoQuantidade: ", rowData, descricaoMes)
        // console.log("viewDetalhamentoQuantidade: ", rowData)
        this.setState({displayDetalhamentoDialog: true})
        // console.log("viewDetalhamentoQuantidade rowData: ", rowData)
        await this.setState({productDetalhamento: {
            // id: rowData.buyProduct.id,
            // descricao: rowData.buyProduct.descricao,
            ...rowData.buyProduct,
            dataInicial: GeneralServices.obterIntervaloFromDescricaoMes(descricaoMes).inicio,
            dataFinal: GeneralServices.obterIntervaloFromDescricaoMes(descricaoMes).fim,
            empresa: rowData.empresa
        } })
        // console.log("viewDetalhamentoQuantidade productDetalhamento: ", this.state.productDetalhamento)
    }  

    hideDetalhamentoDialog = () => {
        this.setState({displayDetalhamentoDialog: false})
        this.setState({productDetalhamento: null})
    }

    renderValorCustoLink = (relatorioInflacaoProdutosCompraItem, rowIndex, index, attribute, isPorcentagem, isLink) => {
        let relatorioMes = relatorioInflacaoProdutosCompraItem.relatorioMesList[index]
        if(!relatorioMes){
            relatorioMes = {
                valorCusto: 0.0
            }
        }
        let valorPuro = relatorioMes[attribute]
        let valorFormatado = valorPuro
        if(isPorcentagem && valorFormatado){
            valorFormatado = valorFormatado*100
        }
        valorFormatado = GeneralServices.showFormattedIfNotNull(valorFormatado, true)
        if(isPorcentagem && valorFormatado){
            valorFormatado = `${valorFormatado}%`
        }

        const condLink = isLink && (Math.abs(valorPuro) > 0) && (relatorioInflacaoProdutosCompraItem.nomeProduto !== ConstantsUtil.mediaTableUpperCaseLabel)

        const classes = classNames({
            'linkValue': condLink,
        });
        
        let retorno = GeneralServices.renderBodyColumnInOneLine(valorFormatado, rowIndex, relatorioMes.valorCusto)

        if(condLink){
            return (
                <a
                    className={classes}
                    onClick={() => this.viewDetalhamentoQuantidade(relatorioInflacaoProdutosCompraItem, relatorioMes.descricaoMes)}                
                >
                    {retorno}
                </a>
            )
        }
        else{
            return(
                <>
                    {retorno}
                </>              
            )
        }
    }

    getClassMesSeparadorLeft = () => {
        return this.state.loading ? '' : 'mes-separador-left'
    }

    getClassMesSeparadorRight = () => {
        return this.state.loading ? '' : 'mes-separador-right'
    }

    getClassMesTopo = () => {
        return this.state.loading ? '' : 'mes-topo'
    }

    formataValorPorcentagem = (valor) => {
        let valorFormatado = valor*100
        valorFormatado = GeneralServices.showFormattedIfNotNull(valorFormatado, true)
        valorFormatado = `${valorFormatado}%`
        return valorFormatado
    }

    getListToExport = () => {

        let exportList = this.state.frontendList.map(item => {
            
            let obj = {
                Produto: item.buyProduct.descricao,
                Fornecedor: item.buyProduct.nomeFornecedor,
            }

            this.state.relatorioInflacao.descricaoMesesList.forEach(descricaoMes => {
                
                let mesIndex = this.state.relatorioInflacao.descricaoMesesList.indexOf(descricaoMes)

                let relatorioMes = item.relatorioMesList[mesIndex]

                Object.assign(obj, {
                    [descricaoMes + " - Valor Custo"]: GeneralServices.formatTo2CasasDecimais(relatorioMes.valorCusto),
                    [descricaoMes + " - Inflação Mensal"]: this.formataValorPorcentagem(relatorioMes.inflacaoMensalPocentagem),
                    [descricaoMes + " - Inflação Acumulada"]: this.formataValorPorcentagem(relatorioMes.inflacaoAcumuladaPocentagem),
                })
            })

            obj["Inflação Total do Período"] = this.formataValorPorcentagem(item.inflacaoTotalPeriodo)

            return obj
        })

        return exportList

    }

    exportExcel = () => {

        AuthService.startBlockUi()

        let exportList = this.getListToExport(false)
        const headersAlignRight = ["Inflação Mensal", "Inflação Acumulada", "Inflação Total do Período"]
        GeneralServices.exportExcel(exportList, "Vendas", "Relatório de Inflação de Produtos de Compra", [], headersAlignRight)

        AuthService.stopBlockUi()

    }

    render() {

        const empresaFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedEmpresaList,
            this.state.relatorioInflacao.itemList,
            "selectedEmpresaList",
            (name, value) => this.setState({[name]: value}),
            'empresa.nome',
            '100%',
            "Empresa"
        )       

        const produtoFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedProdutoList,
            this.state.relatorioInflacao.itemList,
            "selectedProdutoList",
            (name, value) => this.setState({[name]: value}),
            'nomeProduto',
            '100%',
            "Produto"
        )       

        const fornecedorFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedFornecedorList,
            this.state.relatorioInflacao.itemList,
            "selectedFornecedorList",
            (name, value) => this.setState({[name]: value}),
            'nomeFornecedorConcatenado',
            '100%',
            "Fornecedor"
        )       

        const inflacaoTotalFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedInflacaoTotalList,
            this.state.relatorioInflacao.itemList,
            "selectedInflacaoTotalList",
            (name, value) => this.setState({[name]: value}),
            'inflacaoTotalPeriodoFormatadaString',
            '100%',
            "Inflação Total Período"
        )               

        const renderEmpresasMultiSelect = () => {
            if(this.state.unificarEmpresas){
                return (
                    <div className = "col-md-1">
                    <FormGroup label = "Empresas">
                    <EmpresasMultiSelect
                        handleChange={(selectedEmpresas) => this.setState({selectedEmpresas})}
                        placeholder="Selecione as empresas para unificar"
                        inputErrorClass={this.state.inputEmpresasErrorClass}
                        errorMessage={this.state.errorEmpresasErrorMessage}
                        disabled={!this.state.habilitaBusca}
                    />
                    </FormGroup>
                    </div>
                )
            }
        }        

        const renderCalendarFilters = () => {
            return (
                <>
                <div className = "col-md-12">
                    <div className="row">
                        <DateIntervalCalendar
                            htmlFor="SelectDatePeriod"
                            label="Escolher período"
                            ano
                            defaultValue={ConstantsUtil.calendarAnoCompletoFilterLabel}
                            handleFilterChange={this.handleDateFilterChange}
                            handleDateChange={this.handleDateChange}
                            handleInitialMonthDateChange={this.handleInitialMonthDateChange}
                            handleFinalMonthDateChange={this.handleFinalMonthDateChange}
                            missingFilterType={this.state.missingFilterType}
                            missingAnyDate={this.state.missingAnyDate}
                            disabled={!this.state.habilitaBusca}
                        />
                            <div
                                style={{
                                    marginTop: '0.3rem', marginLeft: '0.5rem', marginRight: '0.5rem'
                                }}
                                className = "col-md-1.5"
                            >
                                <h6>Unificar Empresas?</h6>
                                <InputSwitch
                                    checked={this.state.unificarEmpresas}
                                    onChange={this.handleUnificarChange}
                                    disabled={!this.state.habilitaBusca}
                                />
                            </div>

                            {renderEmpresasMultiSelect()}

                        </div>
                </div>
                </>
            )
        }

        const renderButtons = () => {
            if(this.state.habilitaBusca){
                return (
                    <div
                        // style={{marginTop: '0.8rem'}}
                    >
                        <Button
                            label="Gerar Relatório"
                            className='small-button'
                            icon="pi pi-search"
                            onClick = {this.callSearch}
                            // style={ {maxHeight: '35px' } }
                            disabled = {!this.state.habilitaBusca}
                        />
                    </div>
                )
            }
            return (
                <div
                    style={{marginBottom: '0.8rem' } }
                >
                    <Button
                        label="Voltar"
                        className="p-button-danger small-button"
                        icon="pi pi-undo"
                        onClick = {this.toggleButton}
                    />
                    <Button
                        label="Exportar"
                        className="p-button-success small-button"
                        icon="pi pi-file-excel"
                        onClick={this.exportExcel}
                        tooltip={ConstantsUtil.exportXlsxLabel}
                        style ={{marginLeft: '10px'}}
                        tooltipOptions={{position: 'top'}}
                    />
                </div>
            )
        }

        const renderEmpresaColumn = () => {
            if(this.state.unificarEmpresas){
                return (
                    <Column
                        header={
                            <div
                                className='centraliza-conteudo-div'
                                style={{height: '62px'}}
                            >
                                {/* {"Empresa"} */}
                                {empresaFilterElement}
                            </div>
                        }
                        field="empresa.nome"
                        style ={ {width: '200px'} }
                        frozen
                    />                    
                )
            }
        }

        const renderMesesHeaderList = () => {
            if(this.checkListaMesesPreenchida())
                return this.state.relatorioInflacao.descricaoMesesList.map(descricaoMes => {
                    return (
                        <Column
                           className={this.getClassMesTopo()}
                           header={
                           <div
                                className='centraliza-conteudo-div'
                                style={{height: '15px'}}
                            >
                                {descricaoMes}
                            </div>}
                           colSpan={3}
                        />
                    )
                })
        }

        const renderSubColumn = (header, field) => {
            return (
                <Column
                    header={
                        <div
                            className='centraliza-conteudo-div'
                            style={{height: '30px'}}
                        >
                            {header}
                        </div>
                    }
                    field={field}
                />
            )
        }

        const renderMesesSubHeaderList = () => {
            if(this.checkListaMesesPreenchida()){
                let subColumnList = []
                this.state.relatorioInflacao.descricaoMesesList.forEach(descricaoMes => {
                    subColumnList.push(renderSubColumn("Valor Custo", ""))
                    subColumnList.push(renderSubColumn("Inflação Mensal", ""))
                    subColumnList.push(renderSubColumn("Inflação Acumulada", ""))
                })
                // console.log("subColumnList: ", subColumnList)
                return subColumnList
            }
        }

        const headerGroup =
            <ColumnGroup>
                <Row>
                    {renderMesesHeaderList()}
                    <Column
                        className={this.getClassMesTopo()}
                        header={
                            <div
                                className='centraliza-conteudo-div'
                                style={{height: '15px'}}
                            >
                                {inflacaoTotalFilterElement}
                            </div>
                        }
                        field='inflacaoTotalPeriodoFormatadaString'
                        // sortable
                        rowSpan={2}
                    />                    
                </Row>
                <Row>
                    {renderMesesSubHeaderList()}
                </Row>
            </ColumnGroup>        

        const renderMesesColumn = () => {
            var mesesColumnList = []

            if(this.checkListaMesesPreenchida()){
                this.state.relatorioInflacao.descricaoMesesList.forEach(descricaoMes => {
                    mesesColumnList.push(renderMesItem(descricaoMes, ConstantsUtil.valorCustoLabel, this.state.relatorioInflacao.descricaoMesesList.indexOf(descricaoMes), false, true))
                    mesesColumnList.push(renderMesItem(descricaoMes, "inflacaoMensalPocentagem", this.state.relatorioInflacao.descricaoMesesList.indexOf(descricaoMes), true, false))
                    mesesColumnList.push(renderMesItem(descricaoMes, "inflacaoAcumuladaPocentagem", this.state.relatorioInflacao.descricaoMesesList.indexOf(descricaoMes), true, false))
                });
            }

            return mesesColumnList
        }

        const renderMesItem = (descricaoMes, attribute, index, isPorcentagem, isLink) => {
            const isPrimeiraColunaDoMes = attribute === ConstantsUtil.valorCustoLabel
            return (
                <Column
                    header={descricaoMes}
                    className={isPrimeiraColunaDoMes ? this.getClassMesSeparadorLeft() : ''}
                    // field={"nomeProduto"}
                    style ={ {width: ConstantsUtil.widthColumRelatorioFechamentoCaixa} }
                    // style ={ {width: '80px'} }
                    body = { (relatorioInflacaoProdutosCompraItem, rowIndex) => {
                        // console.log("relatorioInflacaoProdutosCompraItem: ", relatorioInflacaoProdutosCompraItem)
                        return(
                          <div className='right-align'>
                            {this.renderValorCustoLink(relatorioInflacaoProdutosCompraItem, rowIndex, index, attribute, isPorcentagem, isLink)}
                          </div>  
                        ) 
                    }
                }
                />
            )
        }

        const renderTable = () => {
            if(!this.state.habilitaBusca){
                return(
                    <DataTable
                        ref={this.dt}
                        // value={this.state.relatorioInflacao.itemList}
                        value={this.state.frontendList}
                        headerColumnGroup={headerGroup}
                        className="p-datatable-sm small-font custom-thick-grid"
                        loading={this.state.loading}
                        rowHover
                        emptyMessage="Não há dados a apresentar"
                        showGridlines
                        onFilter={this.onFilter}
                        rowClassName={this.rowClass}
                        // selection={this.state.selectedContasBancaria}
                        // onSelectionChange={this.handleSelectionChange}
                        scrollable
                        scrollHeight="500px"
                        // frozenWidth={ConstantsUtil.widthColumNomeFrozenTable}
                        frozenWidth={this.state.unificarEmpresas ? "600px" : "400px"}
                        dataKey="nomeProduto"
                        paginator rows={ConstantsUtil.initialTableQuantityOption}
                        paginatorTemplate={GeneralServices.tablePaginatorTemplate(ConstantsUtil.initialTableQuantityOption, this.state.relatorioInflacao.itemList ? this.state.relatorioInflacao.itemList.length : '')}
                        currentPageReportTemplate="Mostrando de {first} ao {last} de {totalRecords} produtos"                    
                    >

                        {renderEmpresaColumn()}

                        <Column
                            header={
                                <div
                                    className='centraliza-conteudo-div'
                                    style={{height: '62px'}}
                                >
                                    {/* {"Produto"} */}
                                    {produtoFilterElement}
                                </div>
                            }
                            field="buyProduct.descricao"
                            // style ={ {width: ConstantsUtil.widthColumNomeFrozenTable} }
                            style ={ {width: '200px'} }
                            frozen
                            // sortable
                            // filter
                            // filterElement={produtoFilterElement}
                            body = { (rowData, rowIndex) => GeneralServices.renderBodyColumnInOneLine(rowData.nomeProduto, rowIndex)}
                        />

                        <Column
                            header={
                                <div
                                    className='centraliza-conteudo-div'
                                    style={{height: '62px'}}
                                >
                                    {/* {"Fornecedor"} */}
                                    {fornecedorFilterElement}
                                </div>
                            }
                            field="nomeFornecedorConcatenado"
                            style ={ {width: '200px'} }
                            frozen
                            // sortable
                            body = { (rowData, rowIndex) => GeneralServices.renderBodyColumnInOneLine(rowData.nomeFornecedorConcatenado, rowIndex)}
                        />

                        {renderMesesColumn()}

                        <Column //Inflação Total do Período
                            className={`${this.getClassMesSeparadorLeft()} ${this.getClassMesSeparadorRight()}`}
                            style ={ {width: '200px'} }
                            field='inflacaoTotalPeriodoFormatadaString'
                        />                        

                    </DataTable>
                )

            }
        }

        const renderDetalhamentoDialog = () => {
            if(this.state.displayDetalhamentoDialog)
                return (
                    <DetalhamentoMovimentacaoProductDialog
                        visible={this.state.displayDetalhamentoDialog}
                        tipo={ConstantsUtil.entradaLabel}
                        product={this.state.productDetalhamento}
                        dataInicial={this.state.productDetalhamento.dataInicial}
                        dataFinal={this.state.productDetalhamento.dataFinal}
                        fromFichaDeEstoque={false}
                        tipoProdutoDetalhamento={ConstantsUtil.tipoDetalhamentoProdutoDeCompraLabel}
                        filtroTipoData={ConstantsUtil.filtroDataEmissaoLabel}
                        hideDialog={this.hideDetalhamentoDialog}
                        unificar={this.state.unificarEmpresas}
                        detalhaEmpresaEspecifica
                    />
                )
        }        

        return(
            <div className="bs-docs-section " >
                <Card
                    title = "Relatório de Inflação de Produtos de Compra"
                    // rightComponent={renderTooltipButton()}
                >
                    
                    <div className = "col-md-12">

                    <div className="row">

                        {renderCalendarFilters()}

                    </div>  

                    <div
                        style={{marginTop: '0.5rem', marginBottom: '0.5rem'}}
                    >
                        {renderButtons()}
                        {renderTable()}
                    </div>
                    
                    </div> {/* col-md-12 */}

                    {renderDetalhamentoDialog()}

                </Card>
                <div className="d-flex "/>
            </div>            
        )
    }

}

InflacaoProdutosCompra.contextType = AuthContext

export default withRouter(InflacaoProdutosCompra)